import { render, staticRenderFns } from "./SearchWeightPromotionForm.vue?vue&type=template&id=3754ef9b&scoped=true&"
import script from "./SearchWeightPromotionForm.vue?vue&type=script&lang=js&"
export * from "./SearchWeightPromotionForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchWeightPromotionForm.vue?vue&type=style&index=0&id=3754ef9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754ef9b",
  null
  
)

export default component.exports